/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForRefreshRecommendation extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForRefreshRecommendation");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForRefreshRecommendation.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForRefreshRecommendation>): BackgroundJobPayloadForRefreshRecommendation {
        let obj = Object.assign(new BackgroundJobPayloadForRefreshRecommendation(), model);
        BackgroundJobPayloadForRefreshRecommendation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForRefreshRecommendation>): BackgroundJobPayloadForRefreshRecommendation {
        if (!model) return null;
        return BackgroundJobPayloadForRefreshRecommendation.newInstance(<BackgroundJobPayloadForRefreshRecommendation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForRefreshRecommendation) {
        if (!obj) return;

        models.BackgroundJobPayloadForRefreshRecommendation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForRefreshRecommendation): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForRefreshRecommendation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    recommendation_id: string;

}
